import { useEffect, useState } from "react";
import { Link } from "@tanstack/react-router";
import { Cookie, X } from "lucide-react";

export function CookieBanner() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (typeof window === "undefined") return;
    if (!localStorage.getItem("prico-cookies")) setShow(true);
  }, []);
  const decide = (v: "all" | "essential") => {
    localStorage.setItem("prico-cookies", v);
    setShow(false);
  };
  if (!show) return null;
  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-6 md:right-auto md:max-w-md z-50 animate-fade-in">
      <div className="card-soft p-5 backdrop-blur-xl bg-card/95">
        <div className="flex items-start gap-3">
          <div className="size-10 grid place-items-center rounded-full bg-primary/10 text-primary shrink-0">
            <Cookie className="size-5" />
          </div>
          <div className="min-w-0 flex-1">
            <h4 className="font-semibold text-sm">Usamos cookies 🍪</h4>
            <p className="text-xs text-muted-foreground mt-1">
              Usamos cookies para mejorar tu experiencia. Lee nuestra{" "}
              <Link to="/cookies" className="text-primary underline">política de cookies</Link>.
            </p>
            <div className="flex gap-2 mt-3">
              <button onClick={() => decide("all")} className="btn-primary text-xs py-1.5 px-3">
                Aceptar todas
              </button>
              <button onClick={() => decide("essential")} className="btn-ghost text-xs py-1.5 px-3">
                Solo esenciales
              </button>
            </div>
          </div>
          <button onClick={() => decide("essential")} aria-label="Cerrar" className="p-1 rounded-full hover:bg-muted">
            <X className="size-4" />
          </button>
        </div>
      </div>
    </div>
  );
}
